const e = {
  container: {
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "nowrap",
    width: "100%",
    minWidth: 0
  },
  contentContainer: {
    justifyContent: "space-between",
    alignItems: "flex-end",
    flexWrap: "nowrap",
    gap: 2
  },
  outlined: {
    border: "1px solid #EFEFEF",
    padding: 4,
    borderRadius: 2
  },
  chip: (t) => ({
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    backgroundColor: `${t.vars?.palette.primary.main ?? t.palette.primary.main}82`,
    color: t.vars?.palette.common.white ?? t.palette.common.white,
    py: 0.5,
    px: 2,
    mt: 4,
    lineHeight: 1.2,
    height: "auto",
    "& .MuiChip-label": {
      padding: 0
    }
  })
};
export {
  e as styles
};
